import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
// import "./../../Products/Faq/Faq.css";
import AskFaq from "./../../../../Images/askFaq.png";
function MfFaq() {
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={8}>
              <h1>Frequently Asked Questions</h1>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Q1. What are Mutual funds?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      A mutual fund is a financial vehicle that draws money from
                      investors and invests those funds in various securities.
                      The mutual fund's holdings are referred to as its
                      portfolio. Professional money managers manage the fund and
                      allocate funds in order to generate the best returns for
                      the investors. They provide access to professionally
                      managed portfolios to small and individual investors.
                      Mutual funds invest in a wide range of securities, and
                      performance is typically measured as the change in the
                      fund's total market cap, which is derived from the
                      aggregation of the underlying investments' performance. A
                      mutual fund employs a fund manager, also known as an
                      investment adviser, who is legally required to act in the
                      best interests of mutual fund shareholders.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Q2. Mutual fund schemes are classified into
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      <li>
                        <span>Equity </span>
                      </li>
                      <li>
                        <span>Debt </span>
                      </li>
                      <li>
                        <span>Hybrid</span>
                      </li>
                      <li>
                        <span>Other Schemes (Index funds, FOF, etc.)</span>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Q3. What is exit load?</Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      Exit Loads are fees levied by mutual funds when an
                      investor sells his or her investments in the funds. Some
                      mutual fund schemes charge an exit load, while others do
                      not. If investors redeem their investments before the
                      expiration date, they will be charged a small fee. The
                      exit load is not counted as part of the scheme's earnings.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Q4. Can Non-Resident Indians invest in Mutual Funds?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      Non-Resident Indians (NRIs) and Persons of Indian Origin
                      (PIOs) can invest in Indian Mutual Funds.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Q5. Is it possible for mutual funds to change their asset
                    allocation while deploying investor funds?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      “Considering the market trends, any prudent fund manager
                      can change the asset allocation, i.e., he can invest
                      higher or lower percentage of the fund in equity or debt
                      instruments compared to what is disclosed in the offer
                      document. It can be done on a short term basis on
                      defensive considerations i.e. to protect the NAV. Hence,
                      the fund managers are allowed certain flexibility in
                      altering the asset allocation considering the interest of
                      the investors. In case the mutual fund wants to change the
                      asset allocation on a permanent basis, they are required
                      to inform the unit holders and give them option to exit
                      the scheme at prevailing NAV without any load.” in a
                      circular by SEBI.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default MfFaq;
